import jQuery from 'jquery';
import RemoveDTRButton from 'ub/ui/inline-text/remove-dtr-button';
import {DTR_TAG_CLASS} from 'ub/ui/inline-text/dynamic-text-defaults';
import dynamicTagHelper from 'ub/data/dtr-tag-helper.js';

let inlineEditor;
let removeDtrButton;

function _sendContentChangedEvent() {
  // We call this for any style changes that do not
  // trigger the 'contentChanged' froala event by default
  inlineEditor.events.trigger('contentChanged');
}

function _removeDynamicTextTag() {
  jQuery(removeDtrButton.currentDtrTarget)
    .replaceWith(removeDtrButton.currentDtrTarget.innerHTML);
  removeDtrButton.hide();
  _sendContentChangedEvent();
}

export function setEditor(inlineEditor0) {
  inlineEditor = inlineEditor0;
}

export function insertDynamicText(defaultText, method, paramUrl) {
  const dynamicTagName = dynamicTagHelper.getDynamicTagName(window.editor);
  inlineEditor.html.insert(
    `<${dynamicTagName}
      class="${DTR_TAG_CLASS}"
      contenteditable="true"
      method="${method}"
      parameter="${paramUrl}"
      title="URL Parameter: ${paramUrl}"
      wrap="true">
        ${defaultText}
      </${dynamicTagName}>`
  );
  _sendContentChangedEvent();
}

export function updateDynamicText($dynamicElement, defaultText, attributes) {
  $dynamicElement.attr({
    defaultText,
    method: attributes.method,
    parameter: attributes.parameter
  });
  $dynamicElement.text(defaultText);

  _sendContentChangedEvent();
}

export function repositionRemoveDtrButton(e) {
  removeDtrButton = removeDtrButton || new RemoveDTRButton(_removeDynamicTextTag.bind(this));
  removeDtrButton.reposition(e.target);
}

export function hideRemoveDtrButton(e) {
  removeDtrButton.safeHide(e.relatedTarget ? e.relatedTarget.className : '');
}

export function showDialog({defaultText, dtrTagAttrs, changeHandler}) {
  window.editor
    .dynamicTextDialog
    .open(defaultText, dtrTagAttrs, (newText, attributes) =>
      changeHandler({defaultText: newText, attributes}));
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/APIs/dynamic-text-api.js